<template>
  <nav class="pb-8 md:px-10 md:pb-0 md:w-fit">
    <ul
      class="flex h-full items-end flex-col gap-4 pt-5 text-lg md:gap-2 md:pt-0 md:text-lg md:font-regular"
      @mouseenter="isHovering = true"
      @mouseleave="isHovering = false"
    >
      <li
        v-for="(link, i) in mainMenuLinks"
        :key="`global_${i}`"
        class="relative"
      >
        <VuepalLink
          :to="link.href"
          class="group h-12 flex overflow-hidden items-center transition-all ease-out duration-300 bg-lightGreen rounded-full text-darkGreen hover:bg-white hover:text-darkGreen border-1 border-lightGreen hover:drop-shadow-[0_4px_30px_rgba(0,0,0,0.05)]"
          :active-class="'main-menu-link-active bg-white text-darkGreen border-1 border-lightGreen filter drop-shadow-[0_4px_30px_rgba(0,0,0,0.05)]'"
        >
          <div
            class="whitespace-nowrap inline-block transition-all ease-out duration-300"
            :class="[
              isScrolled && isHovering
                ? 'opacity-100 max-w-75 transition-all ease-out duration-300'
                : '',
              isScrolled && !isHovering
                ? 'opacity-0 max-w-0 transition-all ease-out duration-300'
                : '',
            ]"
          >
            <span class="p-4">{{ link.label }}</span>
          </div>

          <MediaIcon
            v-if="link.icon"
            v-bind="link.icon"
            class="size-12 p-2 inline-block z-10 bg-lightGreen transition-all ease-out duration-300 group-hover:bg-transparent group-hover:transition-all group-hover:ease-out group-hover:duration-200"
            :class="[
              isHovering
                ? 'bg-transparent transition-all ease-out duration-200'
                : '',
            ]"
          />
          <SpriteSymbol
            v-else
            name="paperplane"
            alt="AOZ logo"
            class="size-12 p-2 inline-block z-10 bg-lightGreen rounded-full transition-all ease-out duration-300 group-hover:bg-transparent group-hover:transition-all group-hover:ease-out group-hover:duration-300"
            :class="[
              isHovering
                ? 'bg-transparent transition-all ease-out duration-300'
                : '',
            ]"
          />
        </VuepalLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, type Ref } from 'vue'

const { mainMenuLinks } = useInitData()
const isHovering = ref(false)
const { isLessThanSm } = useViewport()

const useScroll = (threshold: number = 10): { isScrolled: Ref<boolean> } => {
  const isScrolled = ref<boolean>(false)

  const checkScroll = (): void => {
    isScrolled.value = window.scrollY > threshold && !isLessThanSm.value
  }

  onMounted((): void => {
    checkScroll()
    window.addEventListener('scroll', checkScroll, { passive: true })
  })

  onUnmounted((): void => {
    window.removeEventListener('scroll', checkScroll)
  })

  return { isScrolled }
}

const { isScrolled } = useScroll()
</script>

<style lang="postcss">
.main-menu-link-active {
  svg {
    @apply bg-transparent transition-all ease-out duration-300;
  }
}
</style>
